var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("EditionLieuPortage", {
        ref: "editionLieuPortage",
        attrs: { lieuDePortage: _vm.enEditionLieu, structures: _vm.structures },
        on: {
          "enregistrer-lieu": function($event) {
            return _vm.enregistrerLieu($event)
          },
          "annuler-edition": function($event) {
            return _vm.fermerModalEdition()
          }
        }
      }),
      _c(
        "div",
        { staticClass: "container-fluid" },
        [
          _c("BarreFiltres", {
            attrs: { filtres: _vm.filtres },
            on: {
              "appliquer-filtre": function($event) {
                return _vm.appliquerFiltre($event)
              }
            }
          }),
          _c("BarreActions", {
            attrs: { actions: _vm.actions },
            on: {
              "appliquer-action": function($event) {
                return _vm.executerAction($event)
              }
            }
          }),
          _c(
            "div",
            { staticClass: "card table-scroll height-responsive-100" },
            [
              _vm._m(0),
              _c("div", { staticClass: "table-body" }, [
                _c(
                  "table",
                  { staticClass: "table table-bordered table-sm text-center" },
                  [
                    _vm._m(1),
                    _c(
                      "tbody",
                      [
                        _vm._l(_vm.lieuxFiltres, function(lieu, iLieu) {
                          return [
                            _c(
                              "tr",
                              {
                                key: iLieu,
                                class: [
                                  {
                                    "ligne-selectionnee":
                                      lieu.id === _vm.idLieuSelectionne
                                  },
                                  { "ligne-desactivee": !lieu.actif }
                                ],
                                on: {
                                  click: function($event) {
                                    return _vm.selectionnerLieu(lieu)
                                  }
                                }
                              },
                              [
                                _c(
                                  "td",
                                  {
                                    staticClass: "aligner-gauche",
                                    attrs: {
                                      rowspan: _vm.incrementRowSpan(lieu)
                                    }
                                  },
                                  [_vm._v(_vm._s(lieu.libelle))]
                                ),
                                _c(
                                  "td",
                                  {
                                    staticClass: "aligner-gauche",
                                    attrs: {
                                      rowspan: _vm.incrementRowSpan(lieu)
                                    }
                                  },
                                  [_vm._v(_vm._s(lieu.adresseComplete))]
                                ),
                                _c(
                                  "td",
                                  {
                                    attrs: {
                                      rowspan: _vm.incrementRowSpan(lieu)
                                    }
                                  },
                                  [
                                    _vm.joursOuverture(lieu)
                                      ? _c(
                                          "p",
                                          {
                                            staticStyle: {
                                              "margin-top": "10px"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.joursOuverture(lieu))
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                ),
                                _c("td", [
                                  _vm._v(
                                    _vm._s(lieu.effectifs.length) +
                                      " dont " +
                                      _vm._s(lieu.nombreEffectifsAZero) +
                                      " sans effectif"
                                  )
                                ]),
                                _c("td", [
                                  _vm._v(_vm._s(lieu.nombreEffectifsTotal))
                                ]),
                                _c("td", [
                                  lieu.effectifAvecPlatTemoin
                                    ? _c("i", {
                                        staticClass: "fas fa-check",
                                        staticStyle: {
                                          "margin-right": "2px",
                                          "vertical-align": "middle"
                                        },
                                        attrs: { title: "Plat témoin" }
                                      })
                                    : _vm._e()
                                ])
                              ]
                            ),
                            _vm._l(
                              lieu.effectifs.filter(function(x) {
                                return x.effectif !== 0
                              }),
                              function(effectif, iEffectif) {
                                return [
                                  _vm.detaillerEffectifs
                                    ? _c(
                                        "tr",
                                        {
                                          key:
                                            "lieu-" +
                                            iLieu +
                                            "-effectif-" +
                                            iEffectif,
                                          class: [
                                            {
                                              "ligne-selectionnee":
                                                lieu.id ===
                                                _vm.idLieuSelectionne
                                            },
                                            { "ligne-desactivee": !lieu.actif }
                                          ]
                                        },
                                        [
                                          _c(
                                            "td",
                                            { staticClass: "aligner-gauche" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(effectif.structure) +
                                                  " " +
                                                  _vm._s(effectif.service) +
                                                  " " +
                                                  _vm._s(effectif.regime) +
                                                  " " +
                                                  _vm._s(effectif.texture) +
                                                  " "
                                              )
                                            ]
                                          ),
                                          _c("td", [
                                            _vm._v(
                                              " " +
                                                _vm._s(effectif.effectif) +
                                                " "
                                            )
                                          ]),
                                          _c("td", [
                                            effectif.aPlatTemoin
                                              ? _c("i", {
                                                  staticClass: "fas fa-check",
                                                  staticStyle: {
                                                    "margin-right": "2px",
                                                    "vertical-align": "middle"
                                                  },
                                                  attrs: {
                                                    title: "Plat témoin"
                                                  }
                                                })
                                              : _vm._e()
                                          ])
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              }
                            )
                          ]
                        })
                      ],
                      2
                    )
                  ]
                )
              ])
            ]
          )
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: {
            id: "modalTriLieux",
            size: "xl",
            "hide-footer": "",
            "header-bg-variant": "gradient-bleu",
            "header-text-variant": "light",
            "no-close-on-backdrop": ""
          }
        },
        [
          _c("template", { slot: "modal-title" }, [
            _vm._v(
              " Ordre des lieux de portage (modification par glisser / déposer) "
            )
          ]),
          _c("template", { slot: "default" }, [
            _c(
              "div",
              { key: _vm.keyTri, staticClass: "row" },
              _vm._l(_vm.lieuxTri, function(lieu) {
                return _c(
                  "div",
                  {
                    key: lieu.LieuId,
                    staticClass: "col-xl-3 col-lg-4 col-md-6 col-sm-12",
                    on: {
                      dragstart: function($event) {
                        return _vm.dragStart($event, lieu)
                      },
                      drop: function($event) {
                        return _vm.drop($event, lieu)
                      },
                      dragover: function($event) {
                        return _vm.dragOver($event)
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "card" }, [
                      _c(
                        "div",
                        {
                          class: [
                            {
                              "card-header bg-gradient-bleu text-white":
                                lieu.Actif
                            },
                            {
                              "card-header bg-secondary text-white": !lieu.Actif
                            }
                          ],
                          staticStyle: { "border-radius": "0" },
                          attrs: { draggable: "true" }
                        },
                        [
                          _vm._v(
                            " (" +
                              _vm._s(lieu.Ordre) +
                              ") " +
                              _vm._s(lieu.libelle) +
                              " "
                          )
                        ]
                      )
                    ])
                  ]
                )
              }),
              0
            ),
            _c(
              "div",
              { staticClass: "form-actions right mt-2" },
              [
                _c(
                  "b-button",
                  {
                    staticStyle: { float: "right" },
                    attrs: {
                      type: "submit",
                      variant: "success",
                      alt: "Enregistrer"
                    },
                    on: { click: _vm.enregistrerTri }
                  },
                  [_vm._v("Enregistrer")]
                ),
                _c(
                  "b-button",
                  {
                    staticStyle: { float: "right", "margin-right": "10px" },
                    attrs: {
                      type: "submit",
                      variant: "danger",
                      alt: "Annuler"
                    },
                    on: { click: _vm.annulerTri }
                  },
                  [_vm._v("Annuler")]
                )
              ],
              1
            )
          ])
        ],
        2
      ),
      _c(
        "b-modal",
        {
          attrs: {
            id: "modalEditionJours",
            size: "lg",
            "hide-footer": "",
            "header-bg-variant": "gradient-bleu",
            "header-text-variant": "light",
            "no-close-on-backdrop": ""
          }
        },
        [
          _c("template", { slot: "modal-title" }, [
            _vm._v(" Modifier les jours d'ouverture des lieux de portage ")
          ]),
          _c("template", { slot: "default" }, [
            _c(
              "table",
              {
                staticClass:
                  "table table-bordered table-sm text-center table-header"
              },
              [
                _c("colgroup", [
                  _c("col", { attrs: { width: "*" } }),
                  _c("col", { attrs: { width: "80px" } }),
                  _c("col", { attrs: { width: "80px" } }),
                  _c("col", { attrs: { width: "80px" } }),
                  _c("col", { attrs: { width: "80px" } }),
                  _c("col", { attrs: { width: "80px" } }),
                  _c("col", { attrs: { width: "80px" } }),
                  _c("col", { attrs: { width: "80px" } }),
                  _c("col", { attrs: { width: "80px" } })
                ]),
                _c("thead", [
                  _c("th", [_vm._v("Lieu de portage")]),
                  _c("th", [_vm._v("Lundi")]),
                  _c("th", [_vm._v("Mardi")]),
                  _c("th", [_vm._v("Mercredi")]),
                  _c("th", [_vm._v("Jeudi")]),
                  _c("th", [_vm._v("Vendredi")]),
                  _c("th", [_vm._v("Samedi")]),
                  _c("th", [_vm._v("Dimanche")]),
                  _c("th", [_vm._v("Actif")])
                ])
              ]
            ),
            _c("div", { staticClass: "table-body" }, [
              _c(
                "table",
                { staticClass: "table table-bordered table-sm text-center" },
                [
                  _c("colgroup", [
                    _c("col", { attrs: { width: "*" } }),
                    _c("col", { attrs: { width: "80px" } }),
                    _c("col", { attrs: { width: "80px" } }),
                    _c("col", { attrs: { width: "80px" } }),
                    _c("col", { attrs: { width: "80px" } }),
                    _c("col", { attrs: { width: "80px" } }),
                    _c("col", { attrs: { width: "80px" } }),
                    _c("col", { attrs: { width: "80px" } }),
                    _c("col", { attrs: { width: "80px" } })
                  ]),
                  _c(
                    "tbody",
                    _vm._l(_vm.lieuxJours, function(lieu) {
                      return _c("tr", { key: lieu.id }, [
                        _c("td", [_vm._v(_vm._s(lieu.libelle))]),
                        _c("td", [
                          _c("input", {
                            attrs: { type: "checkbox" },
                            domProps: {
                              checked: lieu.joursOuverture.includes(1)
                            },
                            on: {
                              change: function($event) {
                                return _vm.jourChanged(
                                  lieu,
                                  1,
                                  $event.currentTarget.checked
                                )
                              }
                            }
                          })
                        ]),
                        _c("td", [
                          _c("input", {
                            attrs: { type: "checkbox" },
                            domProps: {
                              checked: lieu.joursOuverture.includes(2)
                            },
                            on: {
                              change: function($event) {
                                return _vm.jourChanged(
                                  lieu,
                                  2,
                                  $event.currentTarget.checked
                                )
                              }
                            }
                          })
                        ]),
                        _c("td", [
                          _c("input", {
                            attrs: { type: "checkbox" },
                            domProps: {
                              checked: lieu.joursOuverture.includes(3)
                            },
                            on: {
                              change: function($event) {
                                return _vm.jourChanged(
                                  lieu,
                                  3,
                                  $event.currentTarget.checked
                                )
                              }
                            }
                          })
                        ]),
                        _c("td", [
                          _c("input", {
                            attrs: { type: "checkbox" },
                            domProps: {
                              checked: lieu.joursOuverture.includes(4)
                            },
                            on: {
                              change: function($event) {
                                return _vm.jourChanged(
                                  lieu,
                                  4,
                                  $event.currentTarget.checked
                                )
                              }
                            }
                          })
                        ]),
                        _c("td", [
                          _c("input", {
                            attrs: { type: "checkbox" },
                            domProps: {
                              checked: lieu.joursOuverture.includes(5)
                            },
                            on: {
                              change: function($event) {
                                return _vm.jourChanged(
                                  lieu,
                                  5,
                                  $event.currentTarget.checked
                                )
                              }
                            }
                          })
                        ]),
                        _c("td", [
                          _c("input", {
                            attrs: { type: "checkbox" },
                            domProps: {
                              checked: lieu.joursOuverture.includes(6)
                            },
                            on: {
                              change: function($event) {
                                return _vm.jourChanged(
                                  lieu,
                                  6,
                                  $event.currentTarget.checked
                                )
                              }
                            }
                          })
                        ]),
                        _c("td", [
                          _c("input", {
                            attrs: { type: "checkbox" },
                            domProps: {
                              checked: lieu.joursOuverture.includes(0)
                            },
                            on: {
                              change: function($event) {
                                return _vm.jourChanged(
                                  lieu,
                                  0,
                                  $event.currentTarget.checked
                                )
                              }
                            }
                          })
                        ]),
                        _c("td", [
                          _c("input", {
                            attrs: { type: "checkbox" },
                            domProps: { checked: lieu.actif },
                            on: {
                              change: function($event) {
                                return _vm.jourChanged(
                                  lieu,
                                  -1,
                                  $event.currentTarget.checked
                                )
                              }
                            }
                          })
                        ])
                      ])
                    }),
                    0
                  )
                ]
              )
            ]),
            _c(
              "div",
              { staticClass: "form-actions right mt-2" },
              [
                _c(
                  "b-button",
                  {
                    staticStyle: { float: "right" },
                    attrs: {
                      type: "submit",
                      variant: "success",
                      alt: "Enregistrer"
                    },
                    on: { click: _vm.enregistrerJours }
                  },
                  [_vm._v("Enregistrer")]
                ),
                _c(
                  "b-button",
                  {
                    staticStyle: { float: "right", "margin-right": "10px" },
                    attrs: {
                      type: "submit",
                      variant: "danger",
                      alt: "Annuler"
                    },
                    on: { click: _vm.fermerJours }
                  },
                  [_vm._v("Annuler")]
                )
              ],
              1
            )
          ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "table",
      { staticClass: "table table-bordered table-sm text-center table-header" },
      [
        _c("colgroup", [
          _c("col", { attrs: { width: "300" } }),
          _c("col"),
          _c("col", { attrs: { width: "170" } }),
          _c("col", { attrs: { width: "400" } }),
          _c("col", { attrs: { width: "80" } }),
          _c("col", { attrs: { width: "80" } })
        ]),
        _c("thead", [
          _c("th", { staticClass: "aligner-gauche" }, [_vm._v("Nom")]),
          _c("th", [_vm._v("Adresse")]),
          _c("th", [_vm._v("Jours ouverture")]),
          _c("th", [_vm._v("Catégories")]),
          _c("th", [_vm._v("Effectifs")]),
          _c("th", [_vm._v("Plat témoin")])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "300" } }),
      _c("col"),
      _c("col", { attrs: { width: "170" } }),
      _c("col", { attrs: { width: "400" } }),
      _c("col", { attrs: { width: "80" } }),
      _c("col", { attrs: { width: "75" } })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }